export default __webpack_public_path__ + "static/media/TextOnlyCommonForm.dfe3f70f.svg";